import { useQueryString } from "src/design-system/core/hooks";
import { useAuth } from "src/hooks";
import { useAmplitude } from "src/hooks/useAmplitude";
import { renderRoutes } from "src/routes";

export const RouterWithAuth = ({ routes }): JSX.Element => {
    const auth = useAuth();

    const [queryString] = useQueryString(["beta"]);
    const openBetaAllowed =
        queryString.beta === "true" && import.meta.env.VITE_FLYNT_ENV !== "production";
    const renderedRoutes = renderRoutes(routes, auth, openBetaAllowed);

    // init d'amplitude ici pour avoir accès a l'auth
    useAmplitude();

    return <>{renderedRoutes}</>;
};
